import React from 'react'
import UploadErrors from '../upload-errors'
import StandardUploader from '../standard-uploader'
import createReactClass from 'create-react-class'



var Local = createReactClass({

	render: function() {
		return (
			<div>
				<header className="ope-section__header">
		          <h2>{_("Upload your photos")} </h2>
		        </header>

		        <UploadErrors />
		        <StandardUploader />

		    </div>
		);
	}
});

export default Local;
